import React from 'react';
import ProductSliderEditor from './ProductSlider.editor';
import ProductSliderProperties from './ProductSlider.properties';
import { registerComponent, registerSkinnableComponent } from '../registry';
import { ProductSliderSkinnable } from './ProductSliderSkinnable';
import ComponentSkinWrapper from '../../skins/ComponentSkinWrapper';
import { COMPONENT_TYPES } from '../../../constants';

// 스킨 가능한 컴포넌트로 등록
registerSkinnableComponent(ProductSliderSkinnable);

// 외부 스킨 지원을 위한 래퍼 컴포넌트
const ProductSliderWrapper: React.FC<any> = (props) => {
  const selectedSkin = props.skin || props.componentProps?.skin || 'basic';
  
  return (
    <ComponentSkinWrapper 
      component={ProductSliderSkinnable}
      componentData={props}
      skinId={selectedSkin}
      mode={props.isPreview ? 'editor' : 'preview'}
      editorProps={props}
    />
  );
};

// 레거시 호환성을 위한 기존 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.PRODUCT_SLIDER || 'ProductSlider',
  component: ProductSliderWrapper,
  editorComponent: ProductSliderEditor,
  properties: ProductSliderProperties,
  defaultProps: {
    style: {
      backgroundColor: 'transparent',
      borderWidth: '1px',
      borderColor: '#eeeeee',
      borderRadius: '0px',
      boxShadow: 'none',
      padding: '0 15px',
      margin: '0'
    },
    componentProps: {
      skin: 'basic',
      sliderTitle: '인기 상품',
      showTitle: true,
      titleFontSize: '18px',
      titleFontWeight: '600',
      titleColor: '#333',
      itemsPerSlide: 4,
      autoSlide: true,
      autoSlideInterval: 3000,
      showStock: false,
      showAddToCart: true,
      showPrice: true,
      cartButtonColor: '#007bff'
    }
  },
  category: 'ecommerce',
  icon: '🛒',
  name: '상품 슬라이더',
  skinnable: ProductSliderSkinnable
});

// 컴포넌트 및 타입 내보내기
export { ProductSliderWrapper as ProductSliderComponent };
export { default as ProductSliderEditor } from './ProductSlider.editor';
export { default as ProductSliderProperties } from './ProductSlider.properties';
export * from './ProductSlider.types';